<template>
  <div class="uk-grid uk-grid-large uk-flex-center" uk-grid>

    <!-- Progress bar -->
    <div class="uk-width-1-1 uk-width-3-5@l">
      <div class="progressbar" v-show="currentStep < 4">
        <div class="progressbar__item" :class="[currentStep == 0 ? 'is-active' : '',currentStep > 0 ? 'is-completed' : '']">
          <div @click="changeStep(0)" class="progressbar__item-inner">
            <div class="progressbar__icon">1</div>
            <div class="progressbar__label">{{ $t('frontend-mtg.configurator.material') }}<br>
              {{ $t('frontend-mtg.configurator.sector') }}
            </div>
          </div>
        </div>
        <div class="progressbar__item" :class="[currentStep == 1 ? 'is-active' : '',currentStep > 1 ? 'is-completed' : '']">
          <div @click="changeStep(1)" class="progressbar__item-inner">
            <div class="progressbar__icon">2</div>
            <div class="progressbar__label">{{ $t('frontend-mtg.configurator.dimensions') }}</div>
          </div>
        </div>
        <div class="progressbar__item" :class="[currentStep == 2 ? 'is-active' : '',currentStep > 2 ? 'is-completed' : '']">
          <div @click="changeStep(2)" class="progressbar__item-inner">
            <div class="progressbar__icon">3</div>
            <div class="progressbar__label">{{ $t('frontend-mtg.configurator.connectors') }}</div>
          </div>
        </div>
        <div class="progressbar__item" :class="[currentStep == 3 ? 'is-active' : '',currentStep > 3 ? 'is-completed' : '']">
          <div @click="changeStep(3)" class="progressbar__item-inner">
            <div class="progressbar__icon">4</div>
            <div class="progressbar__label">{{ $t('frontend-mtg.configurator.summary') }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Configuratore -->
    <div class="uk-width-1-1">

      <!-- Step 0 -->
      <div class="configuratore-section" v-if="currentStep === 0">
        <div class="uk-text-center uk-section-bottom-xsmall">
          <p class="configuratore-section__title uk-h3 uk-text-none uk-text-light" v-html="$t('frontend-mtg.configurator.1_title')"></p>
        </div>
        <div class="uk-grid uk-flex-center" uk-grid>
          <div class="uk-width-1-2@tablet uk-width-1-2@m uk-width-1-3@l">
            <div class="configuratore__type-box_wrapper">
              <label>
                <input type="radio" v-model="configurationType" :value="'material'"/>
                <div class="configuratore__type-box">
                  <div class="configuratore__type-box_icon configuratore__type-box_icon--outside"></div>
                  <p class="configuratore__type-box_title">{{ $t('frontend-mtg.configurator.material') }}</p>
                </div>
              </label>
            </div>
          </div>
          <div class="uk-width-1-2@tablet uk-width-1-2@m uk-width-1-3@l">
            <div class="configuratore__type-box_wrapper">
              <label>
                <input type="radio" v-model="configurationType" :value="'application'"/>
                <div class="configuratore__type-box">
                  <div class="configuratore__type-box_icon configuratore__type-box_icon--inside"></div>
                  <p class="configuratore__type-box_title">{{ $t('frontend-mtg.configurator.application') }}</p>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div v-if="configurationType !== ''" class="uk-section-top-xsmall uk-text-center">
          <p class="uk-h5 uk-text-none uk-text-light">{{ $t('frontend-mtg.configurator.select_the') }}
            <span v-if="configurationType === 'material'">{{ $t('frontend-mtg.configurator.material') }}</span>
            <span v-else>{{ $t('frontend-mtg.configurator.application') }}</span>
          </p>
          <div class=" uk-grid uk-flex-center">
            <div class="form form--thin uk-width-1-2@m" v-if="configurationType === 'material'">
              <select name="material" v-model="outsideMaterial" class="uk-select">
                <option value="">{{ $t('frontend-mtg.configurator.select') }}</option>
                <option v-for="(items, material) in getFormDataValues('materials')" :value="material">
                  {{ $t('frontend-mtg.configurator.form_data.' + material) }}
                </option>
              </select>
              <div v-if="outsideMaterial" class="uk-margin">
                <p class="uk-h5 uk-text-none uk-text-light">
                  {{ $t('frontend-mtg.configurator.material_item') }}
                </p>
                <select name="material-item" v-model="outsideMaterialItem" class="uk-select">
                  <option value="">{{ $t('frontend-mtg.configurator.select') }}</option>
                  <option v-for="material in getFormDataValues('materials')[outsideMaterial]" :value="material">
                    {{ $t('frontend-mtg.configurator.form_data.' + material) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form form--thin uk-width-1-2@m" v-else>
              <select name="application" v-model="insideMaterial" class="uk-select">
                <option value="">{{ $t('frontend-mtg.configurator.select') }}</option>
                <option v-for="application in getFormDataValues('applications')" :value="application">
                  {{ $t('frontend-mtg.configurator.form_data.' + application) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="uk-section-top-xsmall" v-if="outsideMaterial != '' || insideMaterial != ''">
          <div class="uk-grid uk-flex-center" uk-grid>
            <div class="uk-width-1-1 uk-width-auto@s">
              <div class="uk-button uk-button-primary uk-button-chevron" @click="changeStep(1)">
                {{ $t('frontend-mtg.configurator.proceed') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 1 -->
      <div class="configuratore-section" v-if="currentStep === 1">
        <div class="uk-text-center uk-section-bottom-xsmall">
          <p class="configuratore-section__title uk-h3 uk-text-none uk-text-light" v-html="$t('frontend-mtg.configurator.select_tube_size')"></p>
        </div>
        <div class="uk-grid uk-text-center uk-flex-center uk-grid-small">
          <div class="uk-width-1-1 uk-margin-bottom">
            <p class="uk-h5 uk-text-none uk-text-light">{{ $t('frontend-mtg.configurator.inner_dimensions') }}*</p>
            <div class="uk-grid uk-flex-center">
              <div class="form form--thin uk-width-1-2@m">
                <input class="uk-range uk-margin-bottom" v-model="innerDimension" type="range" min="5" max="1000" value="5">
                <input name="inner_dimension" class="uk-input" type="number" min="5" max="1000" v-model="innerDimension"/>
                <!-- TODO: usare classe corretto, spostare testo in dizionario -->
                <p class="uk-text-primary product-card__text uk-margin-remove-bottom uk-text-italic">
                  <strong>*{{ $t('frontend-mtg.configurator.inner_dimension_info_1') }}</strong>
                </p>
                <p class="uk-text-primary product-card__text uk-text-italic" v-if="innerDimension < 10 || (innerDimension > 150 && innerDimension < 200)">
                  <strong>*{{ $t('frontend-mtg.configurator.inner_dimension_info_2') }}</strong>
                </p>

              </div>
            </div>
          </div>
          <div class="uk-width-1-1 uk-margin-bottom">
            <p class="uk-h5 uk-text-none uk-text-light">{{ $t('frontend-mtg.configurator.total_length_meters') }}</p>
            <div class="uk-grid uk-flex-center">
              <div class="form form--thin uk-width-1-2@m">
                <input class="uk-range uk-margin-bottom" v-model="length" type="range" min="1" :max="maxLength" value="1">
                <input name="total_length" class="uk-input" type="number" :value="convertedLength" min="1" :max="maxLength/10" placeholder="Es. 14"/>
              </div>
            </div>
          </div>
          <div class="uk-width-1-1 uk-margin-bottom">
            <p class="uk-h5 uk-text-none uk-text-light">{{ $t('frontend-mtg.configurator.operating_pressure') }}*</p>
            <div class="uk-grid uk-flex-center">
              <div class="form form--thin uk-width-1-2@m">
                <input class="uk-range uk-margin-bottom" v-model="pressure" type="range" min="-1" :max="maxPressure" value="1">
                <input name="total_length" class="uk-input" type="number" :value="convertedPressure" min="-1" :max="maxPressure" placeholder="Es. 14"/>
                <p class="uk-text-primary product-card__text uk-text-italic">
                  <strong>*{{ $t('frontend-mtg.configurator.length_info_1') }}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="uk-width-1-1 uk-margin-bottom">
            <p class="uk-h5 uk-text-none uk-text-light">{{ $t('frontend-mtg.configurator.delivery_time') }}</p>
            <div class="uk-grid uk-flex-center">
              <div class="form form--thin uk-width-1-2@m">
                <select name="delivery_time" v-model="deliveryTime" class="uk-select">
                  <option value="">{{ $t('frontend-mtg.configurator.select') }}</option>
                  <option v-for="delivery_time in getFormDataValues('delivery_times')" :value="delivery_time">
                    {{ $t('frontend-mtg.configurator.form_data.' + delivery_time) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-section-top-xsmall" v-if="innerDimension !== '' && length !== '' && pressure !== '' && deliveryTime !== ''">
          <div class="uk-grid uk-flex-center uk-flex-middle" uk-grid>
            <div class="uk-width-1-1 uk-width-auto@s">
              <div class="uk-button uk-button-secondary uk-button-text uk-button-underline uk-button-underline-primary"
                   @click="changeStep(0)">
                {{ $t('frontend-mtg.configurator.back') }}
              </div>
            </div>
            <div class="uk-width-1-1 uk-width-auto@s">
              <div class="uk-button uk-button-primary uk-button-chevron" @click="changeStep(2)">
                {{ $t('frontend-mtg.configurator.proceed') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="configuratore-section" v-if="currentStep === 2">
        <div class="uk-text-center uk-section-bottom-xsmall">
          <p class="configuratore-section__title uk-h3 uk-text-none uk-text-light" v-html="$t('frontend-mtg.configurator.select_connectors')"></p>
        </div>
        <div class="uk-text-center">
          <div class="uk-grid uk-grid-divider" uk-grid>

            <!-- Raccordi -->
            <div v-for="d in connectorDirections" class="uk-width-1-2@m">
              <p class="uk-h5 uk-text-none uk-text-light">{{ $t('frontend-mtg.configurator.' + d) }}</p>
              <div class="form form--thin uk-margin-bottom">
                <select class="uk-select" v-model="connectorType[d]">
                  <option value="">{{ $t('frontend-mtg.configurator.no_connector') }}</option>
                  <option v-if="filteredCategories.length > 0" value="standard" :name="'connectorType' + d">{{ $t('frontend-mtg.configurator.tube_type_standard') }}</option>
                  <option value="special" :name="'connectorType' + d">{{ $t('frontend-mtg.configurator.tube_type_special') }}</option>
                </select>
                  <p class="uk-text-primary product-card__text uk-text-italic" v-if="filteredCategories.length === 0">
                    <strong>{{ $t('frontend-mtg.configurator.inner_dimension_info_2') }}</strong>
                  </p>
              </div>

              <!-- Raccordo standard -->
              <template v-if="connectorType[d] === 'standard'">
                <div class="form form--thin uk-margin-bottom">
                  <select class="uk-select" v-model="connectorCategory[d]" @change="clearSelection(d)">
                    <option value="">{{ $t('frontend-mtg.configurator.select_category') }}</option>
                    <option v-for="category in filteredCategories" :value="category['position']">{{ category['title'] }}</option>
                  </select>
                </div>
                <div class="uk-grid uk-grid-small" uk-grid v-if="connectorCategory[d]">
                  <div class="uk-width-1-2 uk-width-1-3@tablet uk-width-1-2@m uk-width-1-3@l"
                       v-for="(element, elementKey) in elements[connectorCategory[d]]">
                    <div class="configuratore__connector-box_wrapper">
                      <label>
                        <input type="radio" v-model="connector[d]" :value="elementKey"/>
                        <div class="configuratore__connector-box">
                          <div class="configuratore__connector-box-media">
                            <img :src="getFittingMedia(elementKey,'tube_' + d)" :alt="element.title">
                          </div>
                          <p class="configuratore__connector-box_title">{{ element.title }}</p>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="uk-section-top-xsmall" v-if="connector[d] !== ''">
                  <p class="uk-h5 uk-text-none uk-text-light">{{ $t('frontend-mtg.configurator.select_dimension') }}</p>
                  <div class="form form--thin">
                    <select class="uk-select" v-model="connectorSize[d]">
                      <option value="">{{ $t('frontend-mtg.configurator.select') }}</option>
                      <option v-for="(value, valueKey) in getSizesByElement(connector[d])" :value="valueKey">{{ value }} </option>
                    </select>
                  </div>
                </div>
              </template>

              <!-- Raccordo speciale -->
              <template v-if="connectorType[d] === 'special'">
                <div class="uk-alert uk-text-primary uk-text-left uk-text-small">
                  <p>{{ $t('frontend-mtg.configurator.special_text') }}</p>
                </div>
              </template>

            </div>

          </div>
        </div>
        
        <div class="uk-section-top-xsmall">
          <div class="uk-grid uk-flex-center uk-flex-middle" uk-grid>
            <div class="uk-width-1-1 uk-width-auto@s">
              <div class="uk-button uk-button-secondary uk-button-text uk-button-underline uk-button-underline-primary"
                   @click="changeStep(1)">
                {{ $t('frontend-mtg.configurator.back') }}
              </div>
            </div>
            <div class="uk-width-1-1 uk-width-auto@s">
              <div :class="! fittingsButtonStatus ? 'uk-disabled' : ''" class="uk-button uk-button-primary uk-button-chevron" @click="changeStep(3)">
                {{ $t('frontend-mtg.configurator.proceed') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 3 / Form -->
      <div class="configuratore-section" v-if="currentStep === 3">
        <div class="uk-text-center uk-section-bottom-xxsmall">
          <p class="configuratore-section__title uk-h3 uk-text-none uk-text-light">{{ $t('frontend-mtg.configurator.order_summary') }}</p>
        </div>
        <div class="configuratore__image-wrapper uk-margin-bottom">
          <template v-if="!!leftFittingMedia || !!rightFittingMedia">
            <div class="configuratore__image uk-grid-collapse">
              <img v-if="leftFittingMedia" :src="leftFittingMedia" class="configuratore__image-left">
              <img v-if="rightFittingMedia" :src="rightFittingMedia" alt="" class="configuratore__image-right">
            </div>
          </template>
        </div>
        <rubinred-form :token="token" :action="action" method="POST" ref="form" enctype="multipart/form-data" style="position: relative; z-index: 1;">

          <!-- Form dati riepilogo -->
          <div class="uk-grid uk-flex-center" slot="fields">
            <input type="hidden" name="form_id" :value="formId" v-if="formId">
            <div class="uk-text-center uk-width-1-1">

              <p class="uk-h5 uk-text-none uk-text-light uk-margin-small-bottom" v-if="outsideMaterial">
                <input type="hidden" name="select_tube_by" :value="configurationType">
                <input type="hidden" name="material" :value="outsideMaterial">
                <input type="hidden" name="material-item" v-if="outsideMaterial" :value="outsideMaterial">
                <strong>{{ $t('frontend-mtg.configurator.material_label') }}:</strong>
                {{ $t('frontend-mtg.configurator.form_data.' + outsideMaterial) }}
                <template v-if="outsideMaterialItem">
                  {{ $t('frontend-mtg.configurator.form_data.' + outsideMaterialItem) }}
                </template>
              </p>
              <p class="uk-h5 uk-text-none uk-text-light uk-margin-small-bottom" v-if="insideMaterial">
                <input type="hidden" name="select_tube_by" :value="configurationType">
                <input type="hidden" name="application" :value="insideMaterial">
                <strong>{{ $t('frontend-mtg.configurator.application_label') }}:</strong>
                {{ $t('frontend-mtg.configurator.form_data.' + insideMaterial) }}
              </p>
              <p class="uk-h5 uk-text-none uk-text-light uk-margin-small-bottom" v-if="innerDimension">
                <input type="hidden" name="inner_dimension" :value="innerDimension">
                <strong>{{ $t('frontend-mtg.configurator.inner_dimensions') }}:</strong>
                {{ innerDimension }}
              </p>
              <p class="uk-h5 uk-text-none uk-text-light uk-margin-small-bottom" v-if="length">
                <input type="hidden" name="total_length" :value="convertedLength">
                <strong>{{ $t('frontend-mtg.configurator.total_meters') }}:</strong>
                {{ convertedLength }}
              </p>
              <p class="uk-h5 uk-text-none uk-text-light uk-margin-small-bottom" v-if="pressure">
                <input type="hidden" name="pressure" :value="pressure">
                <strong>{{ $t('frontend-mtg.configurator.operating_pressure') }}:</strong>
                {{ pressure }}
              </p>
              <p class="uk-h5 uk-text-none uk-text-light uk-margin-small-bottom" v-if="deliveryTime">
                <input type="hidden" name="delivery_time" :value="deliveryTime">
                <strong>{{ $t('frontend-mtg.configurator.delivery_time') }}:</strong>
                {{ $t('frontend-mtg.configurator.form_data.' + deliveryTime) }}
              </p>

              <!-- Separatore -->
              <div class="uk-section-xxsmall uk-width-1-1"><hr></div>

              <!-- Raccordo sinistro -->
              <template v-for="d in connectorDirections">
                <p class="uk-h5 uk-text-none uk-text-light">
                  <input type="hidden" :name="'connector_' + d + '_category'" :value="connectorType[d]">
                  <input type="hidden" :name="'connector_' + d + '_element'" :value="connector[d]">
                  <input type="hidden" :name="'connector_' + d + '_size'" :value="connectorSize[d]">
                  <strong>{{ $t('frontend-mtg.configurator.' + d + '_connector') }}:</strong>
  
                  <!-- Nessun raccordo selezionato -->
                  <span v-if="connector[d] === '' && connectorType[d] !== 'special'">{{ $t('frontend-mtg.configurator.no_connector') }}</span>
  
                  <!-- Dati raccordo standard -->
                  <span v-if="connectorType[d] === 'standard'">{{ elements[connectorCategory[d]][connector[d]].title }} - {{ sizes[connector[d]][connectorSize[d]] }}</span>

                  <!-- Dati raccordo speciale -->
                  <span v-if="connectorType[d] === 'special'">{{ $t('frontend-mtg.configurator.special_fitting') }}</span>
                </p>
  
                <!-- File raccordo sinistro -->
                <div class="uk-width-2-3@m uk-width-1-2@l uk-align-center" v-if="connectorType[d] === 'special'">
                  <p class="uk-text-small">{{ $t('frontend-mtg.configurator.fitting_file_format') }}<br/>{{ $t('frontend-mtg.configurator.fitting_file_' + d ) }}</p>
                    <form-file
                      class="configuratore__file"
                      :name="'special_connector_' + d + '_file'"
                      :slug="'special_connector_' + d + '_file'"
                      :label="$t('frontend-mtg.configurator.file_fitting_' + d + '_field')"
                      :hint="$t('frontend-mtg.configurator.select_file')"
                      :validations="validationsFiles"
                    ></form-file>
                </div>

                <!-- Separatore -->
                <div class="uk-section-xxsmall uk-width-1-1"><hr></div>
              </template>
            </div>

            <!-- Form dati richiedente -->
            <div class="uk-width-2-3@m uk-width-1-2@l uk-margin-small">
              <div class="form form--thin uk-form-stacked">
                <div class="form__fields uk-grid uk-grid-small" uk-grid>
                  <div class="uk-width-1-2@s">
                    <div class="uk-form-controls">
                      <form-input
                        name="quantity"
                        slug="quantity"
                        type="number"
                        min="1"
                        placeholder="Es. 200"
                        :label="$t('frontend-mtg.configurator.quantity')"
                        :validations="validationsNumber"
                        required
                      ></form-input>
                    </div>
                  </div>
                  <div class="uk-width-1-2@s">
                    <div class="uk-form-controls">
                      <form-input
                        name="company_name"
                        slug="company_name"
                        :label="$t('frontend-mtg.configurator.company_name')"
                        :validations="validations"
                        required
                      ></form-input>
                    </div>
                  </div>
                  <div class="uk-width-1-2@s">
                    <div class="uk-form-controls">
                      <form-input
                        name="name"
                        slug="name"
                        :label="$t('frontend-mtg.configurator.name')"
                        :validations="validations"
                        required
                      ></form-input>
                    </div>
                  </div>
                  <div class="uk-width-1-2@s">
                    <div class="uk-form-controls">
                      <form-input
                        name="phone"
                        slug="phone"
                        type="tel"
                        :label="$t('frontend-mtg.configurator.phone')"
                        :validations="validations"
                        required
                      ></form-input>
                    </div>
                  </div>
                  <div class="uk-width-1-2@s">
                    <div class="uk-form-controls">
                      <form-input
                        name="province"
                        slug="province"
                        :label="$t('frontend-mtg.configurator.province')"
                        :validations="validations"
                        required
                      ></form-input>
                    </div>
                  </div>
                  <div class="uk-width-1-2@s">
                    <div class="uk-form-controls">
                      <form-input
                        name="email"
                        slug="email"
                        type="email"
                        :label="$t('frontend-mtg.configurator.email')"
                        :validations="validations"
                        required
                      ></form-input>
                    </div>
                  </div>
                  <div class="uk-width-1-1">
                      <form-textarea
                        name="notes"
                        slug="notes"
                        :label="$t('frontend-mtg.configurator.notes')"
                        :validations="validations"
                        required
                      ></form-textarea>
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit -->
            <div class="uk-section-top-xsmall uk-width-1-1 uk-margin-small">
              <div class="uk-grid uk-flex-center" uk-grid>
                <div class="uk-width-1-1 uk-width-auto@s">

                  <div class="gdpr-privacy-agreement__checkbox uk-margin-large-bottom">
                    <form-toggle
                      id="privacy"
                      name="privacy-policy"
                      slug="privacy-policy"
                      :text="$t('frontend-mtg.configurator.form_data.gdpr_label')"
                      :label="$t('frontend-mtg.configurator.form_data.privacy-policy')"
                      :value="false"
                      :validations="['accepted']"
                      required
                      :escape="false"
                    >
                    </form-toggle>
                    <!--                      :text=""-->
                  </div>

                  <form-submit class="uk-button uk-button-primary uk-button-chevron" :label="$t('frontend-mtg.configurator.submit')"></form-submit>
                </div>
              </div>
            </div>

          </div>

        </rubinred-form>

      </div>

    </div>
  </div>

</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    elements: {
      type: Object,
      required: true,
    },
    sizes: {
      type: Object,
      required: true,
    },
    categories: {
      type: Object,
      required: true,
    },
   fittingsMedia: {
      type: Object,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    formId: {
      type: Number,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      validations: ['required'],
      validationsNumber: ['required','numeric','not_in:0','min:1'],
      validationsFiles: ['required','mimes','size'],
      currentStep: 0,
      configurationType: '',
      outsideMaterial: '',
      outsideMaterialItem: '',
      insideMaterial: '',
      innerDimension: 5,
      length: 1,
      pressure: 1,
      deliveryTime: '',
      connectorType: {},
      connectorCategory: {},
      connector: {},
      connectorSize: {},
      connectorDirections: ['left','right'],
    }
  },
  mounted() {
    this.resetFittingSelections();
  },
  computed: {
    filteredCategories: function () {
      return Object.values(this.categories).filter(c => {
        return c.min <= this.innerDimension && c.max >= this.innerDimension;
      });
    },
    maxLength: function () {
      if(this.innerDimension > 254){
        return 120;
      }
      return 400;
    },
    maxPressure: function () {
      if(this.length > 120){
        return 40
      }
      return 15
    },
    convertedLength: function () {
      if(this.innerDimension > 254 && this.length >= 120){
        return 12
      }
      return this.length / 10
    },
    convertedPressure: function () {
      if(this.length < 120 && this.pressure >= 15){
        return 15
      }
      return this.pressure
    },
    leftFittingMedia: function () {
      if(! this.connector['left']){
        return false;
      }
      if(! this.fittingsMedia[this.connector['left']]){
        return false;
      }
      if(! this.fittingsMedia[this.connector['left']]['left']){
        return false;
      }
      return this.fittingsMedia[this.connector['left']]['left'];
    },
    rightFittingMedia: function () {
      if(! this.connector['right']){
        return false;
      }
      if(! this.fittingsMedia[this.connector['right']]){
        return false;
      }
      if(! this.fittingsMedia[this.connector['right']]['right']){
        return false;
      }
      return this.fittingsMedia[this.connector['right']]['right'];
    },
    fittingsButtonStatus: function () {
      // Se viene selezionato il connettore standard, controlla venga impostata anche la misura
      if(this.connectorType['left'] === 'standard'){
        if(this.connector['left'] === ''){
          return false;
        }
      }
      if(this.connectorType['right'] === 'standard'){
        if(this.connector['right'] === ''){
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    clearSelection(d) {
      this.connector[d] = '';
      this.connectorSize[d] = '';
    },
    resetFittingSelections() {
      this.connectorType = {left: '', right: ''};
      this.connectorCategory = {left: '', right: ''};
      this.connector = {left: '', right: ''};
      this.connectorSize = {left: '', right: ''};
    },
    getFittingMedia(fitting, direction) {
      if(this.fittingsMedia[fitting] === undefined){
        return false;
      }
      return this.fittingsMedia[fitting][direction];
    },
    changeStep(value) {
      this.currentStep = value;
    },
    getSizesByElement(element) {
      if (element in this.sizes) {
        return this.sizes[element];
      }
      return false;
    },
    getFormDataValues(element) {
      if (element in this.formData) {
        return this.formData[element];
      }
      return false;
    }
  },
  watch: {
    innerDimension() {
      this.resetFittingSelections();
    }
  }
}
</script>


// WEBPACK FOOTER //
// public/themes/frontend/mtg/assets/js/theme-components/Configuratore.vue